module.exports = __webpack_public_path__ + "static/media/ignite.2b153670.svg";